import { NavLink, Outlet } from "react-router-dom";

// Clear the queue, manage the catalogue, or set what a listing costs.
export function AdminShell() {
  return (
    <div>
      <h1>Admin</h1>
      <nav className="pill-group u-49f14f8">
        <NavLink to="/admin" end>Queue</NavLink>
        <NavLink to="/admin/listings">Listings</NavLink>
        <NavLink to="/admin/pricing">Pricing</NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
